<div>

    <!--Rounds and block indicator during execution-->
    <div style="text-align: -webkit-left;">
        <div *ngIf="started" style="width: 20%;">
            <p style="margin: 0;font-weight: 100;font-size: small;">{{'BLOCK' | translate}}: {{block+1}}/<span>4</span>
            </p>
            <p style="margin: 0;font-weight: 100;font-size: small;">{{'ROUND' | translate}}: {{round+1}}/50</p>
        </div>
    </div>

    <!--TITLE-->
    <h1 *ngIf="!started" style="text-align: center; font-size: 3em; margin-top: 0px;">
        {{'MEM_T3' | translate}}
    </h1>

    <h1 *ngIf="started && recognitionTask==='oldNew'"
        style="text-align: center; font-size: 3em; margin-bottom: 0px;  margin-top: 0px;">
        {{'MEM_T4' | translate}}
    </h1>
    <h1 *ngIf="started && recognitionTask==='source'"
        style="text-align: center; font-size: 3em; margin-bottom: 0px;  margin-top: 0px;">
        {{'MEM_T5' | translate}}
    </h1>

    <!--TASK INSTRUCTIONS AT THE BEGINNING-->
    <div *ngIf="!started && block===0" style="text-align: -webkit-center;text-align: -moz-center;">

        <p>
            {{'MEM_P11' | translate}}
        </p>

        <p>
            {{'MEM_P12' | translate}}
        </p>
        <p>
            {{'MEM_P13' | translate}}
        </p>
        <p [innerHtml]="'MEM_P14' | translate">
        </p>

        <p [innerHtml]="'MEM_P_EXAMPLE' | translate">
        </p>

        <img src="../../../../assets/wordRecognitionExamples/old_new_example.png" width="80%" height="80%">
        <!-- <div style="width: 40%; text-align: -webkit-left; text-align: -moz-left;">
            <p style="margin: 5px;" [innerHtml] = "'MEM_P16' | translate"></p>
            <p style="margin: 5px;" [innerHtml] = "'MEM_P17' | translate"></p>
            <p style="margin: 5px;" [innerHtml] = "'MEM_P18' | translate"></p>
            <p style="margin: 5px;" [innerHtml] = "'MEM_P19' | translate"></p>
            <p style="margin: 5px;" [innerHtml] = "'MEM_P20' | translate"></p>
        </div> -->
        <p [innerHtml]="'MEM_P15' | translate">
        </p>
        <p [innerHtml]="'MEM_P_EXAMPLE' | translate">
        </p>
        <img src="../../../../assets/wordRecognitionExamples/alive_manmade_example.png" width="80%" height="80%">

        <!-- <div style="width: 40%; text-align: -webkit-left; text-align: -moz-left;">
            <p style="margin: 5px;" [innerHtml] = "'MEM_P21' | translate"></p>
            <p style="margin: 5px;" [innerHtml] = "'MEM_P22' | translate"></p>
            <p style="margin: 5px;" [innerHtml] = "'MEM_P23' | translate"></p>
            <p style="margin: 5px;" [innerHtml] = "'MEM_P24' | translate"></p>
            <p style="margin: 5px;" [innerHtml] = "'MEM_P25' | translate"></p>
        </div> -->
    </div>

    <div *ngIf="!started && block===0">
        <button mat-raised-button class="button" (click)="startFunction()">{{'START' | translate}}</button>
    </div>

    <!--BETWEEN BLOCKS SCREEN-->
    <div *ngIf="!started && block!==0" style="text-align: -webkit-center;text-align: -moz-center;">

        <p>
            {{'MEM_P26' | translate}}{{block}}.
        </p>
        <p>
            {{computePercentage()}}% {{'D_P8' | translate}}
        </p>
        <p *ngIf="!(block===4)">
            {{'MEM_P27' | translate}}{{block + 1}}.
        </p>
        <button *ngIf="!(block===4)" mat-raised-button class="button" (click)="startFunction()">{{'START' |
            translate}}</button>
    </div>

    <!--TASK QUESTIONS VIEW-->
    <div *ngIf="started" style="text-align: -webkit-center;text-align: -moz-center;">
        <div style="margin-bottom: 2rem; font-size: 1.5em; margin-top: 3rem;">

            <h3
                style="font-size: 3rem; color: white; width: min-content; padding-top: 15px; padding-bottom: 6px; padding-left: 15px; padding-right: 15px; background-color: #333333; margin-bottom: 0px;">
                {{data[block][round].word.toUpperCase()}}
            </h3>
        </div>

        <div *ngIf="recognitionTask === 'oldNew'" style="display: flex; margin-bottom: 20px;">
            <div class="contentNumber">
                <button class="numbers" mat-raised-button color="white" (click)="vote('1')">
                    {{'MEM_B1' | translate}}
                </button>
            </div>
            <div class="contentNumber">
                <button class="numbers" mat-raised-button color="white" (click)="vote('2')">
                    {{'MEM_B2' | translate}}
                </button>
            </div>
            <div class="contentNumber">
                <button class="numbers" mat-raised-button color="white" (click)="vote('3')">
                    {{'MEM_B3' | translate}}
                </button>
            </div>
            <div class="contentNumber">
                <button class="numbers" mat-raised-button color="white" (click)="vote('4')">
                    {{'MEM_B4' | translate}}
                </button>
            </div>
            <div class="contentNumber">
                <button class="numbers" mat-raised-button color="white" (click)="vote('5')">
                    {{'MEM_B5' | translate}}
                </button>
            </div>
        </div>

        <div *ngIf="recognitionTask === 'source'" style="display: flex; margin-bottom: 20px;">
            <div class="contentNumber">
                <button class="numbers" mat-raised-button color="white" (click)="vote('1')">
                    {{'MEM_B6' | translate}}
                </button>
            </div>
            <div class="contentNumber">
                <button class="numbers" mat-raised-button color="white" (click)="vote('2')">
                    {{'MEM_B7' | translate}}
                </button>
            </div>
            <div class="contentNumber">
                <button class="numbers" mat-raised-button color="white" (click)="vote('3')">
                    {{'MEM_B8' | translate}}
                </button>
            </div>
            <div class="contentNumber">
                <button class="numbers" mat-raised-button color="white" (click)="vote('4')">
                    {{'MEM_B9' | translate}}
                </button>
            </div>
            <div class="contentNumber">
                <button class="numbers" mat-raised-button color="white" (click)="vote('5')">
                    {{'MEM_B10' | translate}}
                </button>
            </div>
        </div>
    </div>

</div>